import React from 'react';
import { Modal } from './Modal';
import { getFitnessTier } from './FitnessBadge';
import './FitnessBadge.css';
import './HelpModal.css';

const FITNESS_TIERS_DATA = [95, 85, 75, 55, 35, 15, 5];
const FITNESS_TIERS = FITNESS_TIERS_DATA.map(getFitnessTier);

interface FitnessInfoModalProps {
    isOpen: boolean;
    onClose: () => void;
    currentFitness?: number;
}

export const FitnessInfoModal: React.FC<FitnessInfoModalProps> = ({ isOpen, onClose, currentFitness }) => {
    const currentTier = currentFitness !== undefined ? getFitnessTier(currentFitness) : null;
    
    return (
        <Modal isOpen={isOpen} onClose={onClose} className="help-modal">
            <h2>Fitness Levels Explained</h2>
            <p>A player's fitness affects their performance and injury risk.</p>
            <p>It decreases after playing a match and recovers during non-playing weeks.</p>
            <ul style={{ listStyle: 'none', padding: 0, marginTop: '16px' }}>
                {FITNESS_TIERS.map(tier => (
                    <li key={tier.label} className={`help-modal-row ${currentTier?.label === tier.label ? 'highlight-row' : ''}`}>
                        <span className={`fitness-badge ${tier.className}`} style={{ flexShrink: 0 }}>{tier.label}</span>
                        <span>{tier.description}</span>
                    </li>
                ))}
            </ul>
            <div className="modal-actions">
                <button className="button" onClick={onClose}>Close</button>
            </div>
        </Modal>
    );
};
